import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout/index.vue'

Vue.use(VueRouter)

// Vue Router 3 在导航到当前路由时会抛出 NavigationDuplicated，全局静默处理
const SILENT_ERRORS = new Set(['NavigationDuplicated', 'NavigationRedirected'])

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject)
  }
  return originalPush.call(this, location).catch(err => {
    if (err && SILENT_ERRORS.has(err.name)) return err
    return Promise.reject(err)
  })
}

const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalReplace.call(this, location, onResolve, onReject)
  }
  return originalReplace.call(this, location).catch(err => {
    if (err && SILENT_ERRORS.has(err.name)) return err
    return Promise.reject(err)
  })
}

/**
 * 常量路由 — 所有页面均为 Root Layout 的子路由，共享同一 Layout 实例。
 * constantRoutes 仅放不需要 addRoute 的固定路由；需要动态注册到 Root 的
 * 系统路由见下方 systemRoutes。
 */
export const constantRoutes = [
  {
    path: '/login',
    component: () => import('@/views/login/index.vue'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/views/error/404.vue'),
    hidden: true
  },
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path(.*)',
        component: () => import('@/views/redirect/index.vue')
      }
    ]
  },
  {
    path: '/',
    name: 'Root',
    component: Layout,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/dashboard/index.vue'),
        meta: { title: '首页', icon: 'el-icon-s-home', affix: true }
      },
      {
        path: '/profile/index',
        name: 'Profile',
        hidden: true,
        component: () => import('@/views/profile/index.vue'),
        meta: { title: '个人中心' }
      }
    ]
  }
]

/**
 * 系统路由 — 需要在路由守卫中通过 router.addRoute('Root', ...) 动态注册。
 * 各页面均为一级菜单，无子菜单分组。
 */
export const systemRoutes = [
  {
    path: '/system/customer',
    name: 'CustomerManage',
    component: () => import('@/views/system/customer/index.vue'),
    meta: { title: '客户管理', icon: 'el-icon-s-custom' }
  },
  {
    path: '/system/car-log',
    name: 'CarLog',
    component: () => import('@/views/system/car-log/index.vue'),
    meta: { title: '识别记录', icon: 'el-icon-document' }
  },
  {
    path: '/system/llm-profile',
    name: 'LlmProfile',
    component: () => import('@/views/system/llm-profile/index.vue'),
    meta: { title: '识别配置档案', icon: 'el-icon-picture-outline' }
  },
  {
    path: '/system/user',
    name: 'UserManage',
    component: () => import('@/views/system/user/index.vue'),
    meta: { title: '管理员管理', icon: 'el-icon-user' }
  },
  {
    path: '/system/config',
    name: 'SystemConfig',
    component: () => import('@/views/system/config/index.vue'),
    meta: { title: '系统配置', icon: 'el-icon-setting' }
  },
  { path: '*', redirect: '/404', hidden: true }
]

const createRouter = () => new VueRouter({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
}

export default router
